import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, ViewChild } from '@angular/core';
import { NavigationService } from '../../../../providers/navigation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ITableColumnHeader } from '../../../../models/table-column-header';
import { Subscription } from 'rxjs';
import { ApiService } from '../../../../providers/api.service';
import { SM_CONSTANTS } from '../../../../shared/constants/sm-constants';

@Component({
  selector: 'sm-payments',
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss']
})
export class PaymentsComponent implements OnInit {
  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  entityHashId: string = '';
  pageTitle: string = 'Transfer history' ;
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;
 
  toDate:any = new Date().toISOString().replace(/T.*/,'').split('-').join('-');
  fromDate:any = ''
  @ViewChild('costTemplate', { static: true })
  costTemplateRef!: TemplateRef<HTMLElement>;
  messageList: any[] = [];
  public loader: boolean = false;
  public visible: boolean = false;
  tableDisplayColumns: ITableColumnHeader[] = [
    {
      columnName: "amount",
      columnProperty: "amount",
      columnTemplate: this.costTemplateRef
    },
    {
      columnName: "notes",
      columnProperty: "notes"
    },
    {
      columnName: "date",
      columnProperty: "creation_time"
    },
    
    
    {
      columnName: "status",
      columnProperty: "transfer_status"
    },
  ];
  private _apiSubscription: Subscription;
  constructor(private _navService: NavigationService, private router: Router, private route: ActivatedRoute, private _apiService: ApiService) {
    this._navService.hideSidebarAndNav = false;
    
    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_ALL_TRANSFERRED_ENTITY_PAYMENT_RESULT){
        console.log(resData);
        this.messageList = resData.result ? resData.result : [];
        this.messageList =     this.messageList.sort((dataA:any, dataB:any) =>
        ((+new Date(dataB['creation_time'])) - (+new 
        Date(dataA['creation_time'])))
 
     )
        console.log( this.messageList);
        
            console.log( this.messageList);
        
      }
      this.loader= false
      this.visible = true;
    });
   }

  ngOnInit(): void {
    
    this.route.queryParams.subscribe(data => {
      console.log(data.entityHash);
      this.entityHashId = data.entityHash

      
    })
   let todayDate = new Date();
   let beforeDate = new Date(todayDate.setMonth(todayDate.getMonth()-1)).toISOString().replace(/T.*/,'').split('-').join('-');
   this.fromDate = beforeDate
  }

  navigate(){
    this.router.navigate(['../'], {relativeTo: this.route ,  queryParamsHandling: 'preserve'})
  }
  search(){
    console.log(this.fromDate);
    console.log(this.toDate);
    this._apiService.getAllTransferredEntityPayment(this.entityHashId, this.fromDate, this.toDate)
    this.visible= false
    this.loader = true
  }
}
